import { useApp } from 'context/AppContext';
import { BackDrop, Container, Header, CloseButton, Content } from './Styles';

const Modal = () => {
  const { state, closeModal } = useApp();
  const { isOpen, header, component: Component, data, allowClose } = state.modal;
  return (
    isOpen && (
      <BackDrop>
        <Container>
          {header && <Header color={header.color}>{header.title}</Header>}
          {allowClose && <CloseButton onClick={closeModal} />}
          <Content>
            <Component data={data} />
          </Content>
        </Container>
      </BackDrop>
    )
  );
};

export default Modal;
